// Componente Card con variantes glassmorphism y efectos hover
import { motion } from 'framer-motion'

const cardVariants = {
  default: 'glass',
  elevated: 'glass-strong',
  cyan: 'glass-cyan',
  solid: 'bg-white dark:bg-navy rounded-xl border border-border-subtle',
}

export default function Card({
  children,
  variant = 'default',
  hover = true,
  padding = 'md',
  className = '',
  onClick,
  as = 'div',
  ...props
}) {
  const paddingClasses = {
    none: '',
    sm: 'p-3',
    md: 'p-5',
    lg: 'p-6',
    xl: 'p-8',
  }

  const Component = onClick ? motion.button : motion[as] || motion.div

  return (
    <Component
      whileHover={hover ? { y: -2, transition: { duration: 0.2 } } : {}}
      onClick={onClick}
      className={`
        rounded-xl transition-all duration-200
        ${cardVariants[variant]}
        ${paddingClasses[padding]}
        ${onClick ? 'cursor-pointer text-left w-full' : ''}
        ${hover ? 'hover:shadow-lg' : ''}
        ${className}
      `}
      {...props}
    >
      {children}
    </Component>
  )
}

// Sub-componente para encabezado de tarjeta
Card.Header = function CardHeader({ children, className = '' }) {
  return (
    <div className={`flex items-center justify-between mb-4 ${className}`}>
      {children}
    </div>
  )
}

// Sub-componente para cuerpo de tarjeta
Card.Body = function CardBody({ children, className = '' }) {
  return (
    <div className={className}>
      {children}
    </div>
  )
}

// Sub-componente para pie de tarjeta
Card.Footer = function CardFooter({ children, className = '' }) {
  return (
    <div className={`mt-4 pt-4 border-t border-border-subtle ${className}`}>
      {children}
    </div>
  )
}
